import {connect} from 'react-redux'
import SlaQuickChanger from "../../Components/Toolbars/TopToolbar/SlaQuickChanger/SlaQuickChanger";
import * as businessActions from "../actions/businessActions";
import * as distributionAreasActions from "../actions/distributionAreasActions";
import {editDefaultSlaAction} from "../actions/businessActions";

const mapStateToProps = (store) => {
    return {
        business: store.businessReducer.business,
        isBusinessChanging: store.businessReducer.changing,
        isDistributionAreasChanging: store.distributionAreasReducer.changing,
        isAreaSlaEnabled: store.businessReducer.business.isAreaSlaEnabled,
        distributionAreas: store.distributionAreasReducer.distributionAreas
    };
};

const mapDispatchToProps = {
    editDefaultSla: businessActions.editDefaultSlaAction,
    editDistributionArea: distributionAreasActions.editDistributionAreaAction
};

const SlaQuickChangerContainer = connect(mapStateToProps, mapDispatchToProps)(SlaQuickChanger);

export default SlaQuickChangerContainer;